import { useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";
import styles from "./MetaPluginsList.module.css";
import PropTypes from "prop-types";
import { MetaPluginItem } from "../MetaPluginItem/MetaPluginItem";
import ViewPluginDetailsModal from "DreamStream/PluginsPage/Shared/ViewPluginDetailsModal";
import PluginDetailsItem from "DreamStream/PluginsPage/Shared/PluginDetailsItem";

import { useDeletePlugins } from "DreamStream/PluginsPage/usePlugins";

/**
 *
 * Scrollable list of meta plugins with a header.
 */

export function MetaPluginsList({ plugins }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  const { deletePlugin } = useDeletePlugins();

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedPlugin, setSelectedPlugin] = useState(null);

  const handleDetails = (data) => {
    setDetailsModalOpen(true);
    setSelectedPlugin(data);
  };

  const handleGroupDelete = () => {
    var deleteObject = {
      type: "meta",
      deleteData: {
        metaId: selectedPlugin.targetId,
        iboNumber: selectedPlugin.plugeeIBONumber,
        groupId: selectedPlugin.targetGroupId,
      },
    };

    deletePlugin.mutateAsync(deleteObject);
  };

  return (
    <div className={styles.container}>
      <div className={classNames(styles.header)}>
        <div className={styles.item}>Plugin IBO</div>
        <div className={styles.item}>Plugin Group</div>
        <div className={styles.item}>Target IBO</div>
        <div className={styles.item}>Target Group</div>
      </div>
      <div className={classNames(styles.dragger)} {...events} ref={ref}>
        {plugins.map((item, index) => (
          <div
            key={index}
            className={classNames(
              styles.whiteBG,
              index % 2 == 1 && styles.slightlyDarkerBackground
            )}
          >
            <MetaPluginItem
              pluginInfo={item}
              onClick={() => handleDetails(item)}
            />
          </div>
        ))}
      </div>

      <ViewPluginDetailsModal
        title="VIEW META PLUGIN DETAILS"
        isOpen={detailsModalOpen}
        errors={[]}
        onClose={() => setDetailsModalOpen(false)}
        onDelete={handleGroupDelete}
        children={
          <>
            {selectedPlugin && (
              <div className={styles["modal-container"]}>
                <div className={styles["detail-container"]}>
                  <div className={styles["label-column"]}>Plugin ID:</div>
                  <div className={styles["detail-column"]}>
                    {selectedPlugin.id}
                  </div>
                </div>
                <div className={styles["detail-container"]}>
                  <div className={styles["label-column"]}>
                    If Users Are in the Group
                  </div>
                  <div className={styles["detail-column"]}>
                    <PluginDetailsItem
                      // src="https://wwguscms.blob.core.windows.net/images/cms/thumbnail/793844d0-334a-11ec-882f-dfd435b7f374/EwiHH-fWUAUavjX.jpeg"
                      name={`${selectedPlugin.plugeeOrganizationName} ${selectedPlugin.plugeeBusinessType}`}
                      isGroup={true}
                      // id={selectedPlugin.plugeeOrganizationId}
                      // id={selectedPlugin.plugeeIBONumber}
                      id={selectedPlugin.plugeeGroupId}
                    />
                  </div>
                </div>
                <div className={styles["detail-container"]}>
                  <div className={styles["label-column"]}>
                    The Sync Will Add Them To The Following Group
                  </div>
                  <div className={styles["detail-column"]}>
                    <PluginDetailsItem
                      // src="https://wwguscms.blob.core.windows.net/images/cms/thumbnail/793844d0-334a-11ec-882f-dfd435b7f374/EwiHH-fWUAUavjX.jpeg"
                      name={`${selectedPlugin.targetOrganizationName} > ${selectedPlugin.targetGroupName}`}
                      isGroup={true}
                      id={selectedPlugin.targetGroupId}
                    />
                  </div>
                </div>

                {/* <div className={styles["detail-container"]}>
                  <div className={styles["label-column"]}>Date Created</div>
                  <div className={styles["detail-column"]}>
                    {`${selectedPlugin.date} ${selectedPlugin.time}`}
                  </div>
                </div> */}
              </div>
            )}
          </>
        }
      />
    </div>
  );
}

MetaPluginsList.propTypes = {
  /**
   * Array of plugin objects.
   */
  plugins: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      baseGroup: PropTypes.string,
      addGroup: PropTypes.string,
      date: PropTypes.string,
      time: PropTypes.string,
    })
  ),
};
